import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import BaseViewer from './Base';
import omit from 'lodash/omit';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/donation.scss';
class DonationViewer extends React.Component {
    render() {
        const restProps = omit(this.props, [
            'theme'
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            className: 'da-editor-donation'
        }, /*#__PURE__*/ React.createElement(BaseViewer, _object_spread_props(_object_spread({
            theme: this.theme
        }, restProps), {
            fixedParagraph: false
        })));
    }
    constructor(props){
        super(props);
        _define_property(this, "theme", void 0);
        this.theme = mergeTheme(baseTheme, this.props.theme);
    }
}
export { DonationViewer as default };
